import {CampaignType} from '../campaigns.types';

function isVideoCampaign(campaignType: CampaignType, excludedCampaignTypes: CampaignType[] = []) {
  return (
    [
      CampaignType.VideoAds,
      CampaignType.InteractiveVideoAds,
      CampaignType.FacebookVideoAds,
      CampaignType.MockSocial,
    ].includes(campaignType) && !excludedCampaignTypes.includes(campaignType)
  );
}

export default isVideoCampaign;
